import { useEffect, useState } from 'react';

/** True when the viewport is narrower than the given breakpoint (default: Tailwind `lg` = 1024px). */
export const useIsSmallScreen = (maxWidth = 1023) => {
  const query = `(max-width: ${maxWidth}px)`;
  const [small, setSmall] = useState(() => (typeof window !== 'undefined' ? window.matchMedia(query).matches : false));
  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = (e) => setSmall(e.matches);
    setSmall(mq.matches);
    if (mq.addEventListener) mq.addEventListener('change', onChange); else mq.addListener(onChange);
    return () => { if (mq.removeEventListener) mq.removeEventListener('change', onChange); else mq.removeListener(onChange); };
  }, [query]);
  return small;
};
